export default [
  {
    title: 'Our Business Processes Algorithms For Manufactures',
    content:
      `Partnering Sailsbib has enabled us to determine data requirements and how it's grouped`,
    customerName: 'Dan Lee',
    customerTitle: 'Director Of Data Analytics',
    customerImage: 'https://i.imgur.com/YsL26k8.png'
  },
  {
    title: 'We Prepare Periodic Reports For Our External Clients',
    content:
      'Teaming up with Sailsbib helped us processes technical systems and workflow',
    customerName: 'Bill Cooper',
    customerTitle: 'Senior Business Analyst',
    customerImage: 'https://i.imgur.com/TSjDAag.png'
  },
  {
    title: 'Day-To-Day Management Of Our Organization',
    content:
      'Collaborating with Sailsbib helped us understand the interests of our company with greater focus',
    customerName: 'Jane Smith',
    customerTitle: 'Consultant Coordinator',
    customerImage: 'https://i.imgur.com/VjYoryH.png'
  }
];
